import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Heart, User, Lock, UserPlus, Crown } from 'lucide-react';

const Register = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    displayName: '',
    role: 'user',
  });
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (formData.password !== formData.confirmPassword) {
      alert('Passwords do not match! 😢');
      return;
    }

    setLoading(true);

    const result = await register({
      username: formData.username,
      password: formData.password,
      displayName: formData.displayName,
      role: formData.role,
    });

    if (result.success) {
      navigate('/dashboard');
    }
    
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-pookie-pink-50 to-pookie-purple-50">
      <div className="max-w-md w-full mx-4">
        <div className="card-cute text-center">
          {/* Logo */}
          <div className="flex justify-center mb-6">
            <div className="bg-gradient-to-r from-pookie-pink-500 to-pookie-purple-500 p-4 rounded-full">
              <Heart className="w-8 h-8 text-white animate-pulse-heart" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-gradient mb-2">Join PookieMart</h1>
          <p className="text-gray-600 mb-8">Create your account and start earning Pookie Points! 💕</p>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="text-left">
              <label className="label-cute">
                <User className="inline w-4 h-4 mr-1" />
                Username
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className="input-cute"
                placeholder="Choose a username"
                required
              />
            </div>

            <div className="text-left">
              <label className="label-cute">
                <Heart className="inline w-4 h-4 mr-1" />
                Display Name
              </label>
              <input
                type="text"
                name="displayName"
                value={formData.displayName}
                onChange={handleChange}
                className="input-cute"
                placeholder="Your cute display name"
                required
              />
            </div>

            <div className="text-left">
              <label className="label-cute">
                <Crown className="inline w-4 h-4 mr-1" />
                Role
              </label>
              <select
                name="role"
                value={formData.role}
                onChange={handleChange}
                className="input-cute"
                required
              >
                <option value="user">User 💕</option>
                <option value="admin">Admin 👑</option>
              </select>
            </div>

            <div className="text-left">
              <label className="label-cute">
                <Lock className="inline w-4 h-4 mr-1" />
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className="input-cute"
                placeholder="Create a password"
                required
              />
            </div>

            <div className="text-left">
              <label className="label-cute">
                <Lock className="inline w-4 h-4 mr-1" />
                Confirm Password
              </label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className="input-cute"
                placeholder="Confirm your password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="btn-primary w-full flex items-center justify-center space-x-2"
            >
              {loading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-2 border-white border-t-transparent"></div>
                  <span>Creating account...</span>
                </>
              ) : (
                <>
                  <UserPlus className="w-4 h-4" />
                  <span>Create Account</span>
                </>
              )}
            </button>
          </form>

          <div className="mt-8 text-center">
            <p className="text-gray-600">
              Already have an account?{' '}
              <Link to="/login" className="text-pookie-pink-600 hover:text-pookie-pink-700 font-semibold">
                Sign in here
              </Link>
            </p>
          </div>
        </div>

        {/* Quick Access Info */}
        <div className="mt-6 text-center text-sm text-gray-500">
          <p>💕 Made with love for Mathew & Kristina 💕</p>
        </div>
      </div>
    </div>
  );
};

export default Register; 